import "./UnlockBenefits.css";

const BENEFITS = [
  {
    id: "certificates",
    image: "https://d2lvj32mp5x83n.cloudfront.net/static/homev2/p1.png",
    title: "Unlimited Access",
    description: "To Indian Culture",
  },
  {
    id: "profiles",
    image: "https://d2lvj32mp5x83n.cloudfront.net/static/homev2/p2.png",
    title: "Multiple Profiles",
    description: "Add & Manage Kids",
  },
  {
    id: "progress",
    image: "https://d2lvj32mp5x83n.cloudfront.net/static/homev2/p3.png",
    title: "Progress Tracking",
    description: "Track learning & insights",
  },
  {
    id: "learning",
    image: "https://d2lvj32mp5x83n.cloudfront.net/static/homev2/p4.png",
    title: "Fun Learning",
    description: "Challenges, not tests",
  },
];

export const UnlockBenefits = () => {
  return (
    <div className="unlockBenefits">
      <h2 className="unlockBenefits__title">What you unlock</h2>

      <div className="unlockBenefits__grid">
        {BENEFITS.map((benefit) => (
          <div key={benefit.id} className="unlockBenefits__item">
            <div className="unlockBenefits__iconWrap">
              <img
                src={benefit.image}
                alt={benefit.title}
                className="unlockBenefits__iconImg"
              />
            </div>
            <div className="unlockBenefits__textWrap">
              <h3 className="unlockBenefits__itemTitle">{benefit.title}</h3>
              <p className="unlockBenefits__itemDesc">{benefit.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="unlockBenefits__note">
        <strong>Note:</strong> All plans are billed annually. The more kids you
        add, the more you save!
      </div>
    </div>
  );
};
